/**
 *
 * Asynchronously loads the component for OnboardingWorkProfile
 *
 */

import { lazyLoad } from 'utils/loadable';

export const OnboardingPlayProfilePage = lazyLoad(
  () => import('./index'),
  module => module.OnboardingPlayProfilePage,
);
